import React, {useState} from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import TopMenu from "../components/TopMenu";
import LeftMenu from "../components/LeftMenu";
import Dashboard from "./admin/Dashboard";
import routes from "../routesConfig";
import PartCategories from "./admin/part/PartCategories";
import PartMasters from "./admin/part/PartMasters";
import PartVariants from "./admin/part/PartVariants";
import PartParameters from "./admin/part/PartParameters";
import Repairs from "./admin/repair/Repairs";
import Parts from "./admin/part/Parts";
import DeviceCategories from "./admin/device/DeviceCategories";
import Devices from "./admin/device/Devices";
import RepairCatalog from "./admin/device/RepairCatalog";
import DiagnosticCatalog from "./admin/device/DiagnosticCatalog";
import "./Admin.css";
import EditRepair from "./admin/repair/edit/EditRepair";
import PartLogs from "./admin/partLog/PartLogs";
import PartOrders from "./admin/partOrder/PartOrders";
import EditPartOrder from "./admin/partOrder/edit/EditPartOrder";
import Users from "./admin/user/Users";
import Buyback from "./admin/buyback/Buyback";
import BuybackEditor from "./admin/buyback/BuybackEditor";
import Customers from "./admin/customer/Customers";
import Settings from "./admin/settings/Settings";
import EmailQueue from "./admin/settings/EmailQueue";
import RepairTimes from "./admin/device/RepairTimes";
import Sales from "./admin/sale/Sales";
import Inquiries from "./admin/inquiry/Inquiries";
import InquiryDetail from "./admin/inquiry/InquiryDetail";
import InquiryCalendar from "./admin/inquiry/InquiryCalendar";
import WebSettings from "./admin/inquiry/WebSettings";

const Admin = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <div className="min-h-screen flex flex-col">
            <TopMenu
                className="flex-shrink-0"
                onMenuToggle={() => setIsMobileMenuOpen(prev => !prev)}
                isMobileMenuOpen={isMobileMenuOpen}
            />
            <div className="flex flex-grow overflow-hidden">
                <LeftMenu
                    className="flex-shrink-0 w-64 bg-gray-800 text-white"
                    isMobileOpen={isMobileMenuOpen}
                    onCloseMobile={() => setIsMobileMenuOpen(false)}
                />
                <div className="flex-1 min-w-0 min-h-0 p-4 overflow-auto">
                    <Routes>
                        <Route path={routes.admin.dashboard} element={<Dashboard/>}/>

                        {/*---------- POŽADAVKY Z WEBU ----------*/}
                        <Route path={routes.admin.inquiries.base} element={<Inquiries/>}/>
                        <Route path={routes.admin.inquiries.calendar} element={<InquiryCalendar/>}/>
                        <Route path={routes.admin.inquiries.settings} element={<WebSettings/>}/>
                        <Route path={routes.admin.inquiries.detail} element={<InquiryDetail/>}/>

                        {/*---------- ZAČÁTEK NÁHRADNÍ DÍLY ----------*/}
                        <Route path={routes.admin.part.categories} element={<PartCategories/>}/>
                        <Route path={routes.admin.part.masters} element={<PartMasters/>}/>
                        <Route path={routes.admin.part.variants} element={<PartVariants/>}/>
                        <Route path={routes.admin.part.parameters} element={<PartParameters/>}/>
                        <Route path={routes.admin.part.parts} element={<Parts/>}/>
                        {/*---------- KONEC NÁHRADNÍ DÍLY ----------*/}

                        <Route path={routes.admin.repairs.base} element={<Repairs/>}/>
                        <Route path={routes.admin.repairs.editRepair} element={<EditRepair/>}/>

                        {/*---------- ZAČÁTEK ZAŘÍZENÍ ----------*/}
                        <Route path={routes.admin.device.categories} element={<DeviceCategories/>}/>
                        <Route path={routes.admin.device.items} element={<Devices/>}/>
                        <Route path={routes.admin.device.repairCatalog} element={<RepairCatalog/>}/>
                        <Route path={routes.admin.device.diagnosticCatalog} element={<DiagnosticCatalog/>}/>
                        <Route path={routes.admin.device.repairTimes} element={<RepairTimes/>}/>
                        {/*---------- KONEC ZAŘÍZENÍ ----------*/}

                        {/*---------- ZAČÁTEK PART LOGy ----------*/}
                        <Route path={routes.admin.partLog.base} element={<PartLogs/>}/>
                        {/*---------- KONEC PART LOGy ----------*/}

                        {/*---------- ZAČÁTEK PART ORDER ----------*/}
                        <Route path={routes.admin.partOrder.base} element={<PartOrders/>}/>
                        <Route path={routes.admin.partOrder.editRepair} element={<EditPartOrder/>}/>
                        {/*---------- KONEC PART ORDER ----------*/}

                        {/*---------- ZAČÁTEK PART LOGy ----------*/}
                        <Route path={routes.admin.users.base} element={<Users/>}/>
                        {/*---------- KONEC PART LOGy ----------*/}

                        {/*---------- ZAČÁTEK VÝKUP ZAŘÍZENÍ ----------*/}
                        <Route path={routes.admin.buyback.base} element={<Buyback/>}/>
                        <Route path={routes.admin.buyback.add} element={<BuybackEditor/>}/>
                        <Route path="buyback/:id" element={<BuybackEditor/>}/>
                        <Route path={routes.admin.sales.base} element={<Sales/>}/>
                        <Route path={routes.admin.sales.editSale} element={<Sales/>}/>
                        {/*---------- KONEC VÝKZP ZAŘÍZENÍ ----------*/}

                        {/*---------- ZAČÁTEK ZÁKAZNÍCI ----------*/}
                        <Route path={routes.admin.customer.base} element={<Customers/>}/>
                        {/*---------- KONEC ZÁKAZNÍCI ----------*/}

                        <Route path={routes.admin.settings.base} element={<Settings/>}/>
                        <Route path={routes.admin.settings.emails} element={<EmailQueue/>}/>

                        <Route
                            path="/part"
                            element={<Navigate replace to={routes.admin.part.categoriesFull}/>}
                        />
                        <Route
                            path="/device"
                            element={<Navigate replace to={routes.admin.device.itemsFull}/>}
                        />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default Admin;
